import gql from "graphql-tag";

export default gql`
	mutation sendEmailToRecoverPassword($email: String!) {
		sendEmailToRecoverPassword(email: $email) {
			success
		}
	}
`;
